var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{style:({
    backgroundColor:
      _vm.colonna.selezionata === 0 ? _vm.colonna.colore_colonna : '#808080',
    border: '1px solid black',
    borderStyle: 'dashed',
    padding: '5px',
  }),attrs:{"cols":_vm.colonna.dimensione},on:{"contextmenu":function($event){$event.stopPropagation();return _vm.handleContextMenuColumn($event)},"mouseup":function($event){$event.stopPropagation();return _vm.handleMouseUp.apply(null, arguments)}}},[(_vm.colonna.oggetto.filter((o) => o.validita == 1).length > 0)?_c('div',{staticStyle:{"background-color":"white"}},[(
        _vm.colonna.oggetto.filter((o) => o.validita == 1)[0].tipo_oggetto === 'B'
      )?_c('span',_vm._l((_vm.colonna.oggetto.filter(
          (o) => o.tipo_oggetto == 'B' && o.validita == 1
        )),function(o,i){return _c('div',{key:i,style:({
          background:
            o.colore_sfondo == 'success'
              ? '#4caf50'
              : o.colore_sfondo == 'error'
              ? '#ff5252'
              : o.colore_sfondo == 'grey lighten-5'
              ? '#FAFAFA'
              : o.colore_sfondo == 'primary'
              ? '#1976d2'
              : o.colore_sfondo,
          display: 'inline-block',
        }),on:{"contextmenu":function($event){$event.stopPropagation();return _vm.handleContextMenuObject($event)}}},[_c('v-icon',{attrs:{"color":o.colore_icona}},[_vm._v(" "+_vm._s(o.icona)+" ")])],1)}),0):(
        _vm.colonna.oggetto.filter((o) => o.validita == 1)[0].tipo_oggetto === 'D'
      )?_c('div',{style:({
        background: _vm.colonna.colore_sfondo,
      }),on:{"contextmenu":function($event){$event.stopPropagation();return _vm.handleContextMenuObject($event)}}},[_c('span',{style:({
          color: _vm.colonna.oggetto.filter((o) => o.validita == 1)[0]
            .font_color_titolo,
          fontSize:
            _vm.colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_size_titolo -
            2 +
            'px',
          fontWeight: _vm.colonna.oggetto.filter((o) => o.validita == 1)[0]
            .font_weight_titolo,
        })},[_vm._v(" "+_vm._s(_vm.colonna.oggetto.filter((o) => o.validita == 1)[0].tooltip)+" ")]),_c('br'),_c('span',{style:({
          color: _vm.colonna.oggetto.filter((o) => o.validita == 1)[0]
            .font_color_dato,
          fontSize:
            _vm.colonna.oggetto.filter((o) => o.validita == 1)[0].font_size_dato -
            2 +
            'px',
          fontWeight: _vm.colonna.oggetto.filter((o) => o.validita == 1)[0]
            .font_weight_dato,
        })},[_vm._v("[Dato] ")])]):(
        _vm.colonna.oggetto.filter((o) => o.validita == 1)[0].tipo_oggetto === 'N'
      )?_c('div',{style:({
        backgroundColor: _vm.colonna.oggetto.filter((o) => o.validita == 1)[0]
          .colore_sfondo,
      }),on:{"contextmenu":function($event){$event.stopPropagation();return _vm.handleContextMenuObject($event)}}},[_c('span',{style:({
          color: _vm.colonna.oggetto.filter((o) => o.validita == 1)[0]
            .font_color_dato,
          fontSize:
            _vm.colonna.oggetto.filter((o) => o.validita == 1)[0].font_size_dato -
            2 +
            'px',
          fontWeight: _vm.colonna.oggetto.filter((o) => o.validita == 1)[0]
            .font_weight_dato,
        })},[_vm._v(" "+_vm._s(_vm.colonna.oggetto.filter((o) => o.validita == 1)[0].tooltip)+" ")])]):(
        _vm.colonna.oggetto.filter((o) => o.validita == 1)[0].tipo_oggetto === 'I'
      )?_c('div',{style:({
        background: _vm.colonna.colore_sfondo,
      }),on:{"contextmenu":function($event){$event.stopPropagation();return _vm.handleContextMenuObject($event)}}},[_vm._v(" ["+_vm._s(_vm.colonna.oggetto.filter((o) => o.validita == 1)[0].testo)+"] ")]):_vm._e()]):_c('v-container',{attrs:{"fluid":""}},_vm._l((_vm.colonna.righe.filter((r) => r.validita == 1)),function(riga,i){return _c('LayoutRow',{key:i,attrs:{"drag_state":_vm.drag_state,"is_intestazione":_vm.is_intestazione,"riga":riga}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }